import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const StarIco: React.FC<PMenuIconProps> = (props) => {
  const { currentColor, classes } = useMenuIcon(props);
  return (
    <svg
      className={classes.ico}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C6.72873 0 0 6.72873 0 15C0 23.2713 6.72873 30 15 30C23.2713 30 30 23.2713 30 15C30 6.72873 23.2713 0 15 0ZM24.7587 12.3687L19.4625 16.4875L21.2275 22.9612C21.2962 23.2124 21.2013 23.4799 20.99 23.6324C20.8813 23.71 20.7538 23.7499 20.6251 23.7499C20.5038 23.7499 20.3838 23.7149 20.2788 23.6449L15 20.1263L9.72123 23.645C9.50496 23.79 9.22125 23.7837 9.00873 23.6325C8.7975 23.48 8.70246 23.2125 8.77125 22.9613L10.5375 16.4875L5.24127 12.3688C5.03004 12.205 4.94754 11.9251 5.03379 11.6725C5.11998 11.42 5.35875 11.25 5.625 11.25H12.0775L14.42 5.3925C14.6101 4.91748 15.3901 4.91748 15.5813 5.3925L17.9225 11.25H24.375C24.6413 11.25 24.88 11.42 24.9663 11.6725C25.0525 11.925 24.97 12.205 24.7587 12.3687Z"
        fill={currentColor}
      />
    </svg>
  );
};
